import {remCalc} from '../../_utils'

interface HelpMeChooseTypes {
    isInitialized: boolean
    isPageMultiSelect: boolean
}

export default {
    baseStyle: ({isInitialized, isPageMultiSelect}: HelpMeChooseTypes) => ({
        mainPageContainer: {flexDir: 'column', background: 'background.default'},
        whitespaceContainer: {height: remCalc(80), background: 'background.default'},
        pageHeaderContainer: {width: '100%', background: 'background.default'},
        pageHeaderInnerContainer: {
            layerStyle: 'full-width',
            flexDir: 'column',
            margin: {base: `${remCalc(40)} auto`, md: `${remCalc(80)} auto ${remCalc(42)} auto`},
            width: '100%',
            padding: {base: `0 ${remCalc(16)}`, lg: `0 ${remCalc(80)}`},
        },
        headerText: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            fontWeight: 'medium',
        },
        headerSubText: {
            textStyle: {base: 'head-large', lg: 'head-xlarge'},
            color: 'text.default',
            fontWeight: 'medium',
            my: 'small.md',
        },
        headerDivider: {color: 'background.grey'},
        stickyBarContainer: {
            justifyContent: 'center',
            width: '100%',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            alignItems: 'center',
            height: {base: remCalc(140), md: remCalc(122)},
            px: {base: 'small.base', md: 'small.md', lg: 'medium.lg', xl: 0},
            background: 'background.default',
            position: isInitialized ? 'sticky' : 'unset',
            display: isInitialized ? 'flex' : 'none',
            bottom: 0,
        },
        stickyBarInnerContainer: {
            layerStyle: 'full-width',
            marginTop: remCalc(24),
            marginBottom: remCalc(24),
            gap: remCalc(32),
            width: '100%',
            flexDir: isPageMultiSelect ? {base: 'column', md: 'row'} : 'row',
            justifyContent: 'space-between',
        },
        stickyBarButtonsContainer: {
            gap: 'small.md',
            justifyContent: 'center',
        },
        refreshBtnContainer: {
            width: {base: isPageMultiSelect ? remCalc(244) : '100%', md: '100%'},
        },
        refreshBtn: {variant: 'icon-button'},
        refreshBtnText: {
            textDecoration: 'underline',
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        resultsContainer: {
            background: 'background.default',
            width: '100%',
            justifyContent: 'center',
            marginBottom: {
                base: 'none',
                lg: remCalc(140),
            },
        },
        resultsInnerContainer: {
            layerStyle: 'full-width',
            maxWidth: 'none',
            mx: {md: 'small.md', lg: 'unset'},
        },
        retrievedProductsContainer: {
            flexDir: {base: 'column', lg: 'row'},
            gap: {base: 'small.lg', md: 'medium.md', lg: 'large.lg'},
            maxWidth: {base: remCalc(361), lg: 'unset'},
            margin: {base: 'auto', lg: 'unset'},
        },
        retrievedProductsImageProps: {
            imageProps: {width: {base: remCalc(300), md: remCalc(288)}},
        },
        goBackBtn: {
            variant: 'secondary',
            minWidth: {base: remCalc(160), md: remCalc(213)},
        },
        proceedBtn: {
            variant: 'primary',
            minWidth: {base: remCalc(160), md: remCalc(213)},
        },
    }),
}
